"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _lodash = _interopRequireDefault(require("lodash"));

var _wistiaButton = _interopRequireDefault(require("../components/wistia-button"));

var _sections = require("../components/contentful-views/sections");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Maps to the Wistia Button content model on Contentful
 * https://app.contentful.com/spaces/ljtyf78xujn2/content_types/wistiaButton/fields}
 * @param {Object} props
 * @param {Object} model
 */
var WistiaButtonWidget = function WistiaButtonWidget(_ref) {
  var model = _ref.model;
  return /*#__PURE__*/_react["default"].createElement(_wistiaButton["default"], _lodash["default"].get(model, 'fields'));
};

WistiaButtonWidget.propTypes = {
  model: _propTypes["default"].shape({})
};
WistiaButtonWidget.defaultProps = {
  model: {}
};
(0, _sections.registerWidget)('wistiaButton', WistiaButtonWidget);
var _default = WistiaButtonWidget;
exports["default"] = _default;